import ko from "knockout"

// Support legacy build system.
window.ko = ko